export default class ReasonFailure {
    id: number;       //ид
    reason = "";   //Причина

}